/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PermissionRuleAction } from './PermissionRuleAction';

/**
 * Permission Rule
 */
export type PermissionRuleRecordItem = {
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * User Unique ID
     */
    userId?: number;
    /**
     * Subject Key - e.g. 'user:4'
     */
    subjectKey?: string;
    /**
     * Rule Type - ROLE or PERMISSION
     */
    ruleType?: PermissionRuleRecordItem.ruleType;
    /**
     * Role Key (if ROLE) or Permission Object Key (if PERMISSION)
     */
    ruleKey?: string;
    /**
     * Scope Type - GLOBAL, TENANT, CUSTOMER
     */
    permissionScope?: PermissionRuleRecordItem.permissionScope;
    /**
     * Scope ID if permissionScope is TENANT or CUSTOMER
     */
    scopeId?: number;
    action?: PermissionRuleAction;
    /**
     * Permission Effect (allow, deny, none)
     */
    effect?: PermissionRuleRecordItem.effect;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * createdBy Unique ID
     */
    createdBy?: number;
    /**
     * updatedBy Unique ID
     */
    updatedBy?: number;
    /**
     * API Response Version
     */
    _ver?: number;
}

export namespace PermissionRuleRecordItem {

    /**
     * Rule Type - ROLE or PERMISSION
     */
    export enum ruleType {
        ROLE = 'role',
        PERMISSION = 'permission',
    }

    /**
     * Scope Type - GLOBAL, TENANT, CUSTOMER
     */
    export enum permissionScope {
        GLOBAL = 'global',
        TENANT = 'tenant',
        CUSTOMER = 'customer',
    }

    /**
     * Permission Effect (allow, deny, none)
     */
    export enum effect {
        ALLOW = 'allow',
        DENY = 'deny',
        NONE = 'none',
    }


}
